function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.12 0 0 .12 130 50)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1250,
  cy: 1250,
  r: 1250
}), /*#__PURE__*/React.createElement("path", {
  d: "m850.487 907.013 399.473 1254.497-592.76-371.42 193.287-883.077 399.473-545.763v382.788l-592.76 1046.052h1186.13l-592.77-1046.052v-382.788l399.48 545.763 193.29 883.077-592.77 371.42 399.48-1254.497",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 100
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "eos-logo",
  clipRule: "evenodd",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 560 400"
}, props), _ref);

export default __webpack_public_path__ + "static/media/eos.2809b56b.svg";
export { SvgComponent as ReactComponent };